module.exports = __webpack_public_path__ + "img/9791160510201.747962b0.jpg";